import React from 'react';
import { Container } from 'react-bootstrap';

import { OscillometryZScoreBar } from '../Components/OscillometryZScoreBar';

import { OscillometryMeasurement } from '../../../Types/Common/src/measurement';

interface OscillometryZScoreChartProps {
  measurements: OscillometryMeasurement | undefined;
};

export const OscillometryZScoreChart: React.FC<OscillometryZScoreChartProps> = ({ measurements }) => {

  if (!measurements) return <Container><p className="error mt-3">Not enough data to render Z-Scores!</p></Container>;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    }}>
      <div style={{
        padding: '24px',
        maxWidth: '672px',
        width: '100%',
        backgroundColor: 'white'
      }}>
        {measurements.R5 !== undefined &&
          <OscillometryZScoreBar
            label="R₅"
            value={measurements.R5.value ?? 0}
            reference={measurements.R5.reference ?? 0}
            zScore={measurements.R5.zScore ?? 0}
            cv={measurements.R5.cv}
            unit={measurements.R5.unit}
            scaleType={'log-r5'}
          />
        }

        {measurements?.R5_20 !== undefined &&
          <OscillometryZScoreBar
            label="R₅₋₂₀"
            value={measurements.R5_20.value ?? 0}
            reference={measurements.R5_20.reference ?? 0}
            zScore={measurements.R5_20.zScore ?? 0}
            cv={measurements.R5_20.cv}
            unit={measurements.R5_20.unit}
            scaleType={'linear'}
          />
        }

        {measurements?.AX !== undefined &&
          <OscillometryZScoreBar
            label="AX"
            value={measurements.AX.value ?? 0}
            reference={measurements.AX.reference ?? 0}
            zScore={measurements.AX.zScore ?? 0}
            cv={measurements.AX.cv}
            unit={measurements.AX.unit}
            scaleType={'log-ax'}
          />
        }
      </div>
    </div>
  );
};